<field-select {(field)}="channel" options="channelOption" ></field-select>
<field-date {(field)}="startHrdr" period="hrdrPeriod" role="start" format="dateTime"></field-date>
<field-date {(field)}="endHrdr" period="hrdrPeriod" max-date="now" role="end" format="dateTime"></field-date>
